import React, {useEffect, useState} from 'react';
import {apiHelperBlockchain} from "../../helper/apiHelper";
import {s3ImageLink, s3Link} from "../../config/ethereum-config";
import {toast} from "react-toastify";
import {useRouter} from "next/router";
import {useTranslation} from "next-i18next";

export const PAGE_SIZE = 20;
function useProfileColList(currLocale) {
    const router = useRouter();
    const { t } = useTranslation();
    const [shareModal, setShareModal] = useState(false)
    const [isCleared, setIsCleared] = useState(false)
    const [isFilterOpen, setIsFilterOpen] = useState(false)
    // const [items, setItems] = useState({ value: 'Most Liked', label: 'Most Liked' });
    // const [ creator, setCreator] = useState({ value: 'Verified only', label: 'Verified only' });
    // const [price, setPrice] = useState({ value: '1 - 5 ETH', label: '1 - 5 ETH' });
    // const [sort, setSort] = useState({ value: 'Recently Added', label: 'Recently Added' });
    const [nftLoader, setNftLoader] = useState(true);
    // const [isButtonShow, setIsButtonShow] = useState(true);
    const [cAddress, setCAddress] = useState(false);
    const [cAddress1, setCAddress1] = useState(false);
    const [filterTags, setFilterTags] = useState({
        price: '',
        status: '',
        category1: '',
        category2: '',
        category3: '',
        category4: '',
        category5: '',
        expiryDate: "",
        ownedByMe: false
    })
    const [category, setCategory] = useState( {
        0: false, 1: false, 2: false, 3: false,4: false
    })
    const [filterSearch, setFilterSearch]=useState('');
    const [filterPriceSort, setFilterPriceSort] = useState(0);
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterCurrency, setFilterCurrency] = useState(1);
    const [filterMinPrice, setFilterMinPrice] = useState(0);
    const [filterMaxPrice, setFilterMaxPrice] = useState(0);
    const [filterEnsClub, setFilterEnsClub] = useState([]);
    const [page, setPage] = useState(1);
    const [allNftList, setAllNftList] = useState([]);
    const [collection, setCollection] = useState({});
    const [collectionCreator, setCollectionCreator] = useState("");
    const [imgType, setImgType] = useState("");
    const [imgName, setImgName] = useState("");
    const [isEditPortion, setIsEditPortion] = useState(false);
    const [isPublic, setIsPublic] = useState(true);
    // const [pWalletAddress, setPWalletAddress] = useState("");
    // const [ipfsData,setIpfsData] = useState("");
    const [coverPhoto, setCoverPhoto] = useState(null);
    const [coverPhotoLoader, setCoverPhotoLoader] = useState(false);
    // const [floorPrice, setFloorPrice] = useState(0);
    // const [totalVolume, setTotalVolume] = useState(0);
    const [totalNft, setTotalNft] = useState(0);
    // const [collapsed, setCollapsed] = useState(false);
    const [isFull, setIsFull] = useState(false);
    const [collectionStr, setCollectionStr] = useState("");
    // const [isImgOk, setIsImgOk] = useState(true);
    // const [imageError, setImageError] = useState("");
    // const [btnDis, setBtnDis] = useState(false);
    const [closePreview, setClosePreview] = useState(false);
    const [imgLoader, setImgLoader] = useState(false);
    const [previewTextHidden, setPreviewTextHidden] = useState(true);
    const [cInnerDetails, setCInnerDetails] = useState("");
    const [isEditProfile, setIsEditProfile] = useState(false);
    const [cData, setCData] = useState({
        cCollectionName: "",
        cCollectionDescription: "",
    });
    const [cErrors, setCErrors] = useState({});
    const [onceClickCollection, setOnceClickCollection] = useState(false);
    const [isCImageLoader, setIsCImageLoader] = useState(false);
    const [cImageError, setCImageError] = useState("");
    const [cCollectionImage, setCCollectionImage] = useState("");
    const [colLoader, setColLoader] = useState(false);
    const [isUpdate, setIsUpdate] = useState(true);
    const [pagination, setPagination] = useState("");
    const [fromDB, setFromDB] = useState(false);
    // const [isWeb3Enabled, setIsWeb3Enabled] = useState(false);
    // const [callbackInstance, setCallbackInstance] = useState(null);
    const [logout, setLogout] = useState(null);
    const [activityLoader, setActivityLoader] = useState(true);
    const [isActivityLoaded, setIsActivityLoaded] = useState(false);
    const [activityList, setActivityList] = useState([]);
    const [activityPage, setActivityPage] = useState(1);
    const [activityCursor, setActivityCursor] = useState('');
    const [totalActivity, setTotalActivity] = useState(0);
    const [filterDays, setFilterDays] = useState(7);
    const [chainIndex, setChainIndex] = useState(null);
    const [viewMoreLoader, setViewMoreLoader] = useState(false);
    const [minClear, setMinClear] = useState(false);
    const [maxClear, setMaxClear] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [key, setKey] = useState("Items");
    const [ownedByMe, setOwnedBy] = useState(false);
    const [characterSet, setCharacterSet] = useState("");

    /*useEffect(() => {
        getCollectionDetails();
    },[])*/
    useEffect(()=>{
        getCollectionDetails();
    },[characterSet, page, filterTags, startDate, endDate, category, maxClear, minClear, filterMinPrice, filterMaxPrice, filterStatus, isCleared, filterEnsClub, isUpdate, filterCurrency, ownedByMe, filterPriceSort, filterSearch])

    const getCollectionDetails = () => {
        let _page = page;
        if (_page === 1) {
            setNftLoader(true);
        }
        if (!fromDB) { _page = pagination; }
        // if (_page === "") { _page = 1; }

        let cList1 = [], user_id="";
        const userId = localStorage.getItem('user_id');
        if (userId) {
            user_id = `&user_id=${userId}`;
        }

        let filterParam = ''
        let wallet_address = localStorage.getItem("walletAddress")
        if (filterSearch) { filterParam += '&search=' + filterSearch }
        if (filterPriceSort) {
            if(filterPriceSort === 4){
                filterParam += '&mostFav=' + true
            }
            if(filterPriceSort === 3){
                filterParam += '&mostViewed=' + true
            }
            filterParam += '&sort=' + filterPriceSort
        }
        let character = ""
        if (filterStatus) { filterParam += '&status=' + filterStatus }
        if(ownedByMe && wallet_address) {
            filterParam += '&wallet_address=' + wallet_address
        }
        if (filterCurrency === 1 && (filterMinPrice > 0 || filterMaxPrice > 0)) {
            filterParam += '&usd=1'
        }
        if (filterMinPrice && filterMinPrice > 0) {
            filterParam += '&min=' + filterMinPrice
        }
        if (filterMaxPrice && filterMaxPrice > 0) {
            filterParam += '&max=' + filterMaxPrice
        }
        if (filterEnsClub.length > 0) {
            filterParam += '&subCategory=' + JSON.stringify(filterEnsClub)
        }
        if (startDate && endDate) {
            filterParam += "&startDate=" + startDate + "&endDate=" + endDate
        }
        if (characterSet === "Letter") {
            character = "&letter=1";
        }else if (characterSet === "Mixed") {
            character = "&alphanumeric=1";
        }else if (characterSet === "Alphabets") {
            character = "&letter=1";
        }else if (characterSet === "Digits") {
            character = "&numbers=1";
        }else if (characterSet === "Emoji") {
            character = "&emoji=1";
        }else {
            character = "&letter=0";
        }

        const apiUrl = 'collection/' + encodeURI(router.query.collectionId) + '?page=' + _page + "&size=" + PAGE_SIZE + user_id + filterParam + character;
        apiHelperBlockchain(apiUrl, 'GET').then(async resp => {

            if (resp.data.status) {
                cList1 = resp.data.data?.nfts?.length ? resp.data.data.nfts : [] ;

                setCollection(resp.data.data.collection);
                setCollectionCreator(resp.data.data.creator ? resp.data.data.creator : null);
                setTotalNft(resp.data.data?.nfts?.length ? resp.data.data.totalNfts : 0);
                setFromDB(resp.data.data.fromDB);
                setChainIndex(resp.data.data.collection.chainIndex);

                if (resp.data.data.pagination) {
                    setPagination(resp.data.data.pagination);
                }

                if (resp.data.data.collection) {
                    let _cData = {
                        cCollectionName: resp.data.data.collection.collection_name,
                        cCollectionDescription: resp.data.data.collection.collection_description
                    };
                    setCData(_cData);
                    setCCollectionImage(resp.data.data.collection.image_url)

                    //get-globalData-for-collection
                    let chid = resp.data.data.collection.chainIndex;

                    if (resp.data.data.collection?.coverPhoto) {
                        let cImg = s3Link + "coverphoto/" + resp.data.data.collection.coverPhoto;
                        document.getElementById('cbgIcon').style.backgroundImage = "url('" + cImg + "')";
                    }

                    let pName = resp.data.data.collection.wallet_address;
                    let cDescription = resp.data.data.collection.collection_description;

                    let pLen = cDescription.length;
                    if (pLen > 157) {
                        setIsFull(true);
                    }
                    setCollectionStr(cDescription);
                    if (localStorage.getItem('walletAddress')) {
                        let wAdr = localStorage.getItem('walletAddress');
                        if (wAdr.toLowerCase() === pName.toLowerCase()) {
                            setIsPublic(false)
                        }
                    }
                    if (isUpdate) {
                        setAllNftList([...allNftList, ...cList1]);
                        setNftLoader(false);
                        setViewMoreLoader(false);
                    }

                    apiHelperBlockchain('get-globalData-for-collection?collection_slug=' + resp.data.data.collection.collection_id + "&chainIndex=" + chid, 'GET').then( resp => {
                        if (resp.data.status) {
                            setCInnerDetails(resp.data.data);
                        }
                    });

                    if (!isActivityLoaded) {
                        await getActivities(resp.data.data.collection);
                        setTimeout(() => {
                            setIsActivityLoaded(true);
                        }, 500);
                    }
                }

            }
            else {
                setCollection({});
                setCollectionCreator("");
                setNftLoader(false);
                setTotalNft(0);
                setFromDB(false);
            }
        }).catch(error => console.error(`Error: ${error}`));
    }

    const getActivities = async (theCollection) => {
        try {
            if ((activityPage > 1 && activityList.length !== totalActivity) || (activityPage === 1)) {
                if (collection.collection_id || theCollection.collection_id) {
                    setActivityLoader(true);
                    const condition = '?contractAddress=' + encodeURI(collection.collection_id) + '&page=' + activityPage + '&size=' + activitySize + '&filterDays=' + filterDays + "&chainIndex=" + chainIndex + (!activityCursor ? '' : "&cursor=" + activityCursor)
                    const res = await apiHelperBlockchain('collection-activity' + condition, 'GET')
                    const resData = res.data
                    setActivityLoader(false);
                    if (resData.status) {
                        const _filterDays = parseInt(resData.data.filterDays) + 7;
                        if (resData.data.activities.length !== totalActivity
                            && resData.data.activities.length < activityList.length + activitySize) {
                            setFilterDays(_filterDays)
                            await getActivities();
                        } else {
                            setActivityList(resData.data.activities || []);
                            setActivityCursor(resData.data.moralisCursor || '');
                            setTotalActivity(resData.data.totalCount);
                            setFilterDays(_filterDays)
                        }
                    }
                }
            }
        } catch (error) {
            console.error(`Error: ${error}`);
            setActivityLoader(false);
        }
    }

    const loadMoreNftActivity = async () => {
        if(key === "Activity") {
            const activity_page = activityPage + 1;
            const filterDays = filterDays + 7;
            setActivityPage(activity_page + 1);
            setFilterDays(filterDays + 7);
            await getActivities();
        }
    }

    const changeSearch = (e) => {
        setAllNftList([]);
        setFilterSearch(e.target.value);
        setPage(1);
    }
    const changePriceSort = (sort) => {
        setFilterPriceSort(sort);
        setPage(1);
        setAllNftList([]);
    }
    const applyExpiryDates = (start_date, end_date) => {
        const startDate = new Date(start_date * 1000).toDateString()
        const endDate = new Date(end_date * 1000).toDateString()
        const expiryTag = "Expiration Date : " + startDate + " To " + endDate
        setStartDate(start_date);
        setEndDate(end_date);
        setPage(1);
        setAllNftList([]);
        setFilterTags({
            ...filterTags,
            expiryDate: expiryTag
        })
    }

    const changeOptions = (option) => {
        let status_tag = ""
        if (option === 1) {
            status_tag = "Buy Now"
        }
        if (option === 2) {
            status_tag = "Live Auctions"
        }
        setFilterStatus(option);
        setPage(1);
        setAllNftList([]);
        setFilterTags({
            ...filterTags,
            status: status_tag
        })
    }

    const changeOwnedOption = (option) => {
        setOwnedBy(option);
        setPage(1);
        setAllNftList([]);
        setFilterTags({
            ...filterTags,
            ownedByMe: option
        })
    }

    const changeCharacterType = (option) => {
        setCharacterSet(characterSet === option ? "" : option);
        setPage(1);
        setAllNftList([]);
        setFilterTags({
            ...filterTags,
            characterSet: characterSet === option ? "" : option
        })
    }

    const applyPrice = (min_price, max_price, currency) => {
        let price_tag = ''
        if (min_price) {
            price_tag = "Min " + min_price + ` ${currency === 1 ? "USD" : (chainIndex === 1 ? "ETH" : "MATIC")}`
        }
        if (max_price) {
            price_tag += `${min_price > 0 ? "," : ""}` + "Max " + max_price + ` ${currency === 1 ? "USD" : (chainIndex === 1 ? "ETH" : "MATIC")}`
        }
        setFilterCurrency(currency);
        setFilterMinPrice(min_price);
        setFilterMaxPrice(max_price);
        setPage(1);
        // setSize(8)
        setAllNftList([]);
        setFilterTags({
            ...filterTags,
            price: price_tag
        })
    }

    const changeEnsCategory = (option, selectedCategoryListMenu) => {
        const addcategoryData = []
        let category1 = "", category2 = "", category3 = "", category4 = "", category5 = "";

        if (selectedCategoryListMenu[0]) {
            category1 = "category : Arabic 999 club"
            addcategoryData.push("arabic999_club")
        }
        if (selectedCategoryListMenu[1]) {
            category2 = "category : Arabic 10k club"
            addcategoryData.push("arabic10k_club")
        }
        if (selectedCategoryListMenu[2]) {
            category3 = "category : Arabic 100k club"
            addcategoryData.push("arabic100k_club")
        }
        if (selectedCategoryListMenu[3]) {
            category4 = "category : 100k club"
            addcategoryData.push("100k_club")
        }
        if (selectedCategoryListMenu[4]) {
            category5 = "category : 10k club"
            addcategoryData.push("10k_club")
        }


        setCategory({...selectedCategoryListMenu});
        setFilterEnsClub(addcategoryData);
        setPage(1);
        setAllNftList([]);
        setFilterTags({
            ...filterTags,
            category1,
            category2,
            category3,
            category4,
            category5
        })
    }


    const loadMoreNft = () => {
        setIsUpdate(true);
        setPage(page + 1);
        setViewMoreLoader(true);
    }

    const changeCoverFile = (e) => {
        setCoverPhoto({ coverPhoto: e.target.files[0] });
        const file = e.target.files[0];

        let is_img_ok = true;
        let imgType = "";
        let imgName = "";

        if (file) {
            const sizeLimit = 50 * 1024 * 1024;

            imgName = file.name;
            let imgSize = file.size;
            imgType = file.type;

            const fileExt = imgName.split('.').pop();

            const acceptFiles = [
                "image/png",
                "image/x-citrix-png",
                "image/x-png",
                "image/jpeg",
                "image/x-citrix-jpeg",
                "image/gif",
                "image/bmp",
                "image/avif",
                "image/svg+xml",
                "image/webp"
            ];

            if (!acceptFiles.includes(imgType)) {
                is_img_ok = false;
                // setImageError(t('common:only_accept')+ fileExt);
                // setBtnDis(false);
                toast.error(t('common:only_accept') + " " + fileExt);
            }
            if (imgSize > sizeLimit) {
                is_img_ok = false;
                // setImageError(t('common:img_size_must_be'));
                // setBtnDis(false);
                toast.error(t('common:img_size_must_be'));
            }

            if (is_img_ok) {
                setImageInFileReader(file);
                setImgType(imgType);
                setImgName(imgName);
                setPreviewTextHidden(false);
            }
        }
    }

    const savePhoto = async () => {
        if (coverPhoto) {
            setCoverPhoto(true);
            // setBtnDis(true);

            // upload image in IPFS
            try {

                // upload image S3 bucket
                let nPass = { contentType: imgType, name: imgName };

                const accessToken = localStorage.getItem("accessToken");
                let authentication = null;
                if (accessToken) {
                    authentication = { "authorization": `Bearer ${accessToken}` }
                }

                const res = await apiHelperBlockchain('get-collections-coverphoto-url', 'POST', nPass, authentication)
                if (res.data.status) {

                    let uploadURL = res.data.data.uploadURL;

                    let iArr = uploadURL.split("?");
                    let iUrl = iArr[0];

                    try {
                        let binary = atob(coverPhoto.split(',')[1])
                        let array = []
                        for (let i = 0; i < binary.length; i++) {
                            array.push(binary.charCodeAt(i))
                        }
                        let blobData = new Blob([new Uint8Array(array)], {
                            type: imgType
                        });
                        const result = await fetch(uploadURL, {
                            method: 'PUT',
                            body: blobData
                        })

                        if (result) {
                            const dPass = {
                                coverPhoto: iUrl.split("https://s3.me-south-1.amazonaws.com/cdn.upyo.com/coverphoto/")[1],
                                collection_id: collection.collection_slug,
                                wallet_address: collection.wallet_address
                            }

                            const accessToken = localStorage.getItem("accessToken");
                            let authentication = null;
                            if (accessToken) {
                                authentication = { "authorization": `Bearer ${accessToken}` }
                            }

                            const res = await apiHelperBlockchain("edit-collection-details", "post", dPass, authentication);

                            if (res.data.status) {
                                setIsEditPortion(!isEditPortion);
                                setCoverPhotoLoader(false);
                                setIsUpdate(false);
                                setPreviewTextHidden(true);
                                getCollectionDetails();
                                toast(t('common:collection_cover_success'));
                            }
                            else {
                                toast(res.data.message);
                            }
                        }

                        setImgLoader(false);
                        setClosePreview(false);
                        // setBtnDis(false);
                    } catch (error) {
                        console.log(error);
                        setImgLoader(false);
                        // setImageError(error);
                        // setBtnDis(false);
                    }
                }
            } catch (error) {
                console.log(error);
                setImgLoader(false);
                // setImageError(error);
                // setBtnDis(false);
            }
        } else {
            toast.error(t('common:select_image'));
        }
    }


    const setImageInFileReader = (file) => {
        setClosePreview(false);
        const reader = new FileReader();
        reader.onloadend = () => {
            let cImg = reader.result;
            document.getElementById('cbgIcon').style.backgroundImage = "url('" + cImg + "')";
            setCoverPhoto(reader.result);
        }
        reader.readAsDataURL(file);
    }

    // Copy Address
    const copyAddress = async (pAddress, stateName) => {
        if(stateName === "cAddress"){
            setCAddress(true);
        }else{
            setCAddress1(true);
        }
        await navigator.clipboard.writeText(pAddress);
        // setCAddress(false);
    }

    const change_c_photo = async (e) => {
        setIsCImageLoader(true);
        try {
            const imgData = new FormData();
            imgData.append('image', e.target.files[0]);

            const accessToken = localStorage.getItem("accessToken");
            let authentication = null;
            if (accessToken) {
                authentication = { "authorization": `Bearer ${accessToken}` }
            }

            apiHelperBlockchain('upload-collectible', 'POST', imgData, authentication).then(res => {

                if (res.data.status) {
                    let iData = res.data.data;

                    // set errors
                    let c_err = cErrors;
                    c_err.c_collection_image = "";

                    setCErrors(c_err);
                    setCCollectionImage(s3ImageLink + iData.fileNameAWS);
                    setIsCImageLoader(false);
                    setCImageError("");
                } else {
                    setIsCImageLoader(false);
                    setCImageError(res.data.message);
                }
            }).catch((error) => {
                if (error.response && error.response.status === 403) {
                    localStorage.clear();
                    logout();
                    window.location = "/" + currLocale + "/nft" + "/login";
                }
            })
        } catch (error) {
            console.log('Error uploading file: ', error);
        }
    }

    //c_formValidation
    const c_formValidation = () => {

        const { cCollectionName, cCollectionDescription } = cData;

        // Form validation
        let err = {};
        if (!cCollectionName) { err.cCollectionName = "Display name required"; }
        if (!cCollectionDescription) { err.cCollectionDescription = "Description required"; }
        if (!cCollectionImage) { err.c_collection_image = "Select Image"; }

        setCErrors(err);
    }

    const updateCollection = async () => {
        setOnceClickCollection(true);
        if (localStorage.getItem('walletAddress')) {
            c_formValidation();

            if (cCollectionImage && cData.cCollectionName !== "" && cData.cCollectionDescription !== "") {
                setColLoader(true);

                let cData = {
                    collectionId: collection._id,
                    collectionName: cData.cCollectionName,
                    collectionDescription: cData.cCollectionDescription,
                    collectionProfilePhoto: cCollectionImage,
                };

                const accessToken = localStorage.getItem("accessToken");
                let authentication = null;
                if (accessToken) {
                    authentication = { "authorization": `Bearer ${accessToken}` }
                }

                apiHelperBlockchain('update-collection', 'POST', cData, authentication).then(res => {

                    if (res.data.status) {
                        toast.success(t('common:update_collection_success'));
                        setColLoader(false);
                        setOnceClickCollection(false);
                        setIsEditProfile(false);
                        setIsUpdate(false);
                        getCollectionDetails();
                    }
                    else {
                        toast.error(res.data.message);
                    }
                }).catch((error) => {
                    if (error.response && error.response.status === 403) {
                        localStorage.clear();
                        logout();
                        window.location = "/" + currLocale + "/nft" + "/login";
                    }
                })
            }
        }
        else {
            toast.error('please login');
        }
    }

    // Form Events
    const c_handleChange = event => {
        const c_data = cData
        c_data[event.target.name] = event.target.value;

        if (onceClickCollection) {
            c_formValidation();
        }
        setCData(c_data);
    };

    const validURL = (str) => {
        const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    const refreshMetadata = (db_id, new_item) => {
        let nData = allNftList;
        const indexOfItemInArray = nData.findIndex(q => q._id === db_id);

        if (indexOfItemInArray > -1) {
            nData[indexOfItemInArray].imageUrl = new_item.imageUrl;
        }
    }

    const cancelUploadImage = (e) => {
        e.preventDefault()
        setIsEditPortion(false);
        setCoverPhotoLoader(false);
        setPreviewTextHidden(true);
        let cImg = s3Link + "coverphoto/" + collection.coverPhoto;
        document.getElementById('cbgIcon').style.backgroundImage = "url('" + cImg + "')";
    }

    const clearAllFilters = (e) => {
        e.preventDefault();

        setFilterTags({
            ...filterTags,
            price: '',
            status: "",
            category1: "",
            category2: "",
            category3: "",
            category4: "",
            category5: "",
            expiryDate: "",
            characterSet: ""
        })
        setCharacterSet("");
        // setCurrency(0);
        setCategory({
            0: false, 1: false, 2: false, 3: false, 4: false
        })
        setFilterStatus(0);
        setFilterEnsClub([]);
        setPage(1);
        setAllNftList([]);
        setFilterMinPrice(0);
        setFilterMaxPrice(0);
        setStartDate("");
        setEndDate("");
        setMinClear(true);
        setMaxClear(true);
        // setPriceType(0);
        // setCreator(false);
        setIsCleared(true);
    }

    const clear_min_max = () => {
        setMinClear(false);
        setMaxClear(false);
    }

    const clearFilterTag = (tag) => {
        switch (tag) {
            case "status":
                setFilterTags({
                    ...filterTags, status:""
                })
                setFilterStatus(0);
                setPage(1);
                setAllNftList([]);
                // setMinPrice("");
                // setMaxPrice("");
                setMinClear(true);
                setMaxClear(true);
                // setPriceType(0)
                break;
            case "price":
                // setCurrency(0);
                setFilterMinPrice(0);
                setFilterMaxPrice(0);
                setPage(1);
                setAllNftList([]);
                setMinClear(true);
                setMaxClear(true);
                setFilterTags({
                    ...filterTags, price: ""
                })
                break;
            case "category1":
                // setType(0);
                setPage(1);
                setAllNftList([]);
                setFilterTags({
                    ...filterTags, category1: ""
                })
                setCategory({
                    ...category, 0:false
                })
                break;
            case "category2":
                // setType(0);
                setPage(1);
                setAllNftList([]);
                setFilterTags({
                    ...filterTags, category2: ""
                })
                setCategory({
                    ...category, 1: false
                })
                break;
            case "category3":
                // setType(0);
                setPage(1);
                setAllNftList([]);
                setFilterTags({
                    ...filterTags, category3: ""
                })
                setCategory({
                    ...category, 2: false
                })

                break;
            case "category4":
                // setType(0);
                setPage(1);
                setAllNftList([]);
                setFilterTags({
                    ...filterTags, category4: ""
                })
                setCategory({
                    ...category, 3:false
                })
                // getCollectionDetails();
                break;
            case "category5":
                // setType(0);
                setPage(1);
                setAllNftList([]);
                setFilterTags({
                    ...filterTags, category4: ""
                })
                setCategory({
                    ...category, 4: false
                })
                break;

            case "expiryDate":
                // setType(0)
                setPage(1);
                setAllNftList([]);
                setFilterTags({
                    ...filterTags, category4: ""
                })
                setCategory({...category, 4:false});
                break;
            case "characterSet":
                setCharacterSet("");
                // setType(0);
                setPage(1);
                setAllNftList([]);
                setFilterTags({
                    ...filterTags, characterSet: ""
                })
                setStartDate("");
                setEndDate("");
                break;
            default:
                break;
        }
    }

    return {
        page,
        shareModal,
        setShareModal,
        isFilterOpen,
        setIsFilterOpen,
        nftLoader,
        cAddress,
        cAddress1,
        filterTags,
        category,
        filterStatus,
        collection,
        collectionCreator,
        isPublic,
        coverPhotoLoader,
        totalNft,
        isFull,
        setIsFull,
        isCleared,
        setIsCleared,
        collectionStr,
        previewTextHidden,
        cInnerDetails,
        isEditProfile,
        setIsEditProfile,
        cData,
        cErrors,
        isCImageLoader,
        cImageError,
        cCollectionImage,
        activityLoader,
        activityList,
        activityPage,
        chainIndex,
        viewMoreLoader,
        minClear,
        maxClear,
        key,
        setKey,
        ownedByMe,
        characterSet,
        isEditPortion,
        setIsEditPortion,
        allNftList,
        loadMoreNftActivity,
        changeSearch,
        changePriceSort,
        applyExpiryDates,
        changeOptions,
        changeOwnedOption,
        changeCharacterType,
        applyPrice,
        changeEnsCategory,
        loadMoreNft,
        changeCoverFile,
        savePhoto,
        copyAddress,
        change_c_photo,
        updateCollection,
        c_handleChange,
        validURL,
        refreshMetadata,
        cancelUploadImage,
        clearAllFilters,
        clear_min_max,
        clearFilterTag
    };
}

export default useProfileColList;